import React from "react";
import { Link } from "react-router-dom";
import MobileBar from "./mobile_bar";
import logo from "../../dist/img/logo.png";

const FacebookIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const TwitterIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
  </svg>
);

const Footer = () => {
  return (
    <>
      <MobileBar />
      <footer className="bg-slate-900 text-slate-400 py-12 px-6 border-t border-slate-800 hidden lg:block">
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
            {/* Brand Section */}
            <div className="space-y-4">
              <Link to="/" className="inline-block">
                <img src={logo} alt="Rekpark Logo" className="w-[180px] brightness-0 invert" />
              </Link>
              <p className="text-sm text-slate-400 font-medium">
                Рекпарк — удобный сайт объявлений в Кыргызстане. Покупайте и продавайте товары и услуги быстро и безопасно.
              </p>
            </div>

            {/* Links Columns */}
            <div className="grid grid-cols-2 gap-6 md:col-span-2">
              <div>
                <h3 className="text-white text-sm font-semibold tracking-wider uppercase mb-4">Навигация</h3>
                <ul className="space-y-2.5 text-sm">
                  <li>
                    <Link to="/" className="hover:text-white transition">Главная</Link>
                  </li>
                  <li>
                    <Link to="/" className="hover:text-white transition">Для бизнеса</Link>
                  </li>
                  <li>
                    <Link to="/articles" className="hover:text-white transition">Статьи</Link>
                  </li>
                  <li>
                    <Link to="/help" className="hover:text-white transition">Помощь</Link>
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-white text-sm font-semibold tracking-wider uppercase mb-4">Документы и инфо</h3>
                <ul className="space-y-2.5 text-sm">
                  <li>
                    <Link to="/agreement" className="hover:text-white transition">Пользовательское соглашение</Link>
                  </li>
                  <li>
                    <Link to="/about" className="hover:text-white transition">О нас</Link>
                  </li>
                  <li>
                    <Link to="/" className="hover:text-white transition">Все объявления</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <hr className="border-slate-800 my-8" />

          {/* Bottom Section */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-xs text-slate-500 text-center md:text-left">
              &copy; {new Date().getFullYear()} Рекпарк. Все права защищены.
            </p>

            {/* Social Icons */}
            <div className="flex space-x-5 text-slate-500">
              <a href="#" className="hover:text-white transition" aria-label="Facebook">
                <FacebookIcon />
              </a>
              <a href="#" className="hover:text-white transition" aria-label="Instagram">
                <InstagramIcon />
              </a>
              <a href="#" className="hover:text-white transition" aria-label="Twitter">
                <TwitterIcon />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;